import { render, staticRenderFns } from "./infoMsg.vue?vue&type=template&id=25cea860&scoped=true&"
import script from "./infoMsg.vue?vue&type=script&lang=js&"
export * from "./infoMsg.vue?vue&type=script&lang=js&"
import style0 from "./infoMsg.vue?vue&type=style&index=0&id=25cea860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cea860",
  null
  
)

export default component.exports